import { useState } from 'react';
import { Search } from '@nazka/nazka.mapframe.components';

import './map-search.css';

const aqtPotApiUrl = '/api/aqt-pot-api';
const searchResultTypeLabels = {
  gemeente: 'Gemeente',
  stat_sector: 'Statistische sector',
  stromend_water: 'Stromend Water',
  stilstaand_water: 'Stilstaand Water',
  rwzi: 'RWZI',
  collector: 'Collector',
};

const searchResultRoutes = {
  gemeente: id => `/afnemers/${id}`,
  stat_sector: async (id, apiBaseUrl) => {
    const response = await fetch(`${apiBaseUrl}/stat-sector/${id}`);
    if (!response.ok) {
      throw new Error(`Statistical sector request failed with status ${response.status}`);
    }

    const sector = await response.json();
    const municipalityId = sector?.ID_gemeente ?? sector?.properties?.ID_gemeente;

    if (municipalityId === undefined || municipalityId === null) return undefined;

    return `/afnemers/${encodeURIComponent(String(municipalityId))}/${id}`;
  },
  stromend_water: id => `/bronnen/stromend-water/${id}`,
  stilstaand_water: id => `/bronnen/stilstaand-water/${id}`,
  rwzi: id => `/bronnen/rwzi/${id}`,
  collector: id => `/bronnen/collector/${id}`,
};

function MapSearch({ navigate }) {
  const [options, setOptions] = useState([]);
  const [searchKey, setSearchKey] = useState(0);

  const handleSearch = async (query, _options, signal) => {
    setOptions([]);

    const endpoint = `${aqtPotApiUrl}/search?q=${encodeURIComponent(query)}`;

    try {
      const response = await fetch(endpoint, { signal });
      if (!response.ok) {
        throw new Error(`Search request failed with status ${response.status}`);
      }

      const results = await response.json();
      if (signal.aborted) return;

      setOptions(
        results
          .map(result => ({
            id: `${result.type}-${result.id}`,
            label: result.naam,
            data: result,
          })),
      );
    } catch (error) {
      if (error.name !== 'AbortError') {
        setOptions([]);
      }
    }
  };

  const handleSelect = async (item) => {
    const input = document.querySelector('.maplibregl-ctrl-search .map-search__search__input');
    if (input) input.value = '';
    setSearchKey(key => key + 1);

    const result = typeof item === 'object' ? item?.data : undefined;
    if (!result?.id || !result?.type) return;

    const encodedId = encodeURIComponent(String(result.id));

    const routeBuilder = searchResultRoutes[result.type];
    if (!routeBuilder) return;

    try {
      const route = await routeBuilder(encodedId, aqtPotApiUrl);
      if (route) navigate(route);
    } catch {
      return;
    }
  };

  return (
    <div className="map-search">
      <Search
        key={searchKey}
        clear
        className="map-search__search"
        customMenuItems={({ data, highlighted, label }) => (
          <div className={`map-search__result${highlighted ? ' map-search__result--highlighted' : ''}`}>
            <span className="map-search__result-name">{label}</span>
            <span className="map-search__result-type">
              {searchResultTypeLabels[data?.type] ?? data?.type}
            </span>
          </div>
        )}
        onSearch={handleSearch}
        onSelect={handleSelect}
        options={options}
        placeholder="Zoek..."
        noResultsText="Geen resultaten..."
      />
    </div>
  );
}

export default MapSearch;
